import ReactGA from "react-ga4";
import {
  Grid,
  Button,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
  Box,
  Fade,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
  Stack,
} from "@mui/material";
import { useState, useEffect } from "react";

import { getImages } from "../utils/getImages";
import Overlay from "../components/Overlay";

function Home({ canPlaySounds, audio, theme, darkMode }) {

  const [sessionType, setSessionType] = useState("timed");
  const [gender, setGender] = useState("both");
  const [skinType, setSkinType] = useState("wire");
  const [timeLimit, setTimeLimit] = useState(10);
  const [modalOpen, setModalOpen] = useState(false);
  const [randomImg, setRandomImg] = useState("");
  const [images, setImages] = useState([]);
  const abortCont = new AbortController();

  useEffect(() => {
    ReactGA.send({ hitType: "pageview", page: "/", page_title: 'Random Pose Tool' });
  }, [])

  useEffect(() => {
    getImages(setImages, gender, skinType, abortCont);
    return () => {
      abortCont.abort();
    };
  }, [gender, skinType]);

  const startSession = () => {
    setModalOpen(true);
    refreshImg();
  };





  const refreshImg = () => {
    let randomIndex = Math.floor(Math.random() * images.length);
    let image = images[randomIndex];
    images.splice(randomIndex, 1);
    setImages(images);
    setRandomImg(image);

    if (canPlaySounds && typeof image !== "undefined") audio.play();
  };

  const stopSession = () => {
    setModalOpen(false);
    // re-fetch the images since we ran out
    getImages(setImages, gender, skinType,abortCont);
  };

  return (
    <Fade in={true} timeout={500}>
    <Stack className="home" direction="column" spacing={4}>
      <Stack direction="row" spacing={4} justifyContent="center">
        <Button
          style={{ width: "140px" }}
          disableElevation
          size="large"
          color="secondary"
          variant={sessionType === "timed" ? "contained" : "outlined"}
          onClick={() => {
            setSessionType("timed");
          }}
        >
          Timed
        </Button>
        <Button
          style={{ width: "140px" }}
          disableElevation
          size="large"
          color="secondary"
          variant={sessionType === "nontimed" ? "contained" : "outlined"}
          onClick={() => {
            setSessionType("nontimed");
          }}
        >
          Not Timed
        </Button>
      </Stack>
      <Stack direction="column" justifyContent="center" alignItems="center">
        {sessionType === "timed" ? (
          <Grid item container justifyContent="center">
            <Box mb={4}>
              <FormControl fullWidth>
                <InputLabel id="timeSelector">Select Time</InputLabel>
                <Select
                  labelId="timeSelector"
                  value={timeLimit}
                  label="Select Time"
                  onChange={(e) => setTimeLimit(parseInt(e.target.value))}
                >
                  <MenuItem value="10">10 Seconds</MenuItem>
                  <MenuItem value="15">15 Seconds</MenuItem>
                  <MenuItem value="30">30 Seconds</MenuItem>
                  <MenuItem value="60">1 minute</MenuItem>
                  <MenuItem value="120">2 minutes</MenuItem>
                  <MenuItem value="300">5 minutes</MenuItem>
                  <MenuItem value="600">10 minutes</MenuItem>
                </Select>
              </FormControl>
            </Box>
          </Grid>
        ) : (
          ""
        )}
        <Grid item>
          <Box mb={4}>
            <FormControl component="fieldset">
              <FormLabel component="legend">Gender</FormLabel>
              <RadioGroup
                row
                aria-label="gender"
                name="gender"
                value={gender}
                onChange={(e) => {
                  setGender(e.target.value);
                }}
              >
                <FormControlLabel
                  value="female"
                  control={<Radio />}
                  label="Female"
                />
                <FormControlLabel
                  value="male"
                  control={<Radio />}
                  label="Male"
                />
                <FormControlLabel
                  value="both"
                  control={<Radio />}
                  label="Both"
                />
              </RadioGroup>
            </FormControl>
          </Box>
        </Grid>
        <Grid item>
          <Box mb={4}>
            <FormControl component="fieldset">
              <FormLabel component="legend">Type</FormLabel>
              <RadioGroup
                row
                aria-label="gender"
                name="type"
                value={skinType}
                onChange={(e) => setSkinType(e.target.value)}
              >
                <FormControlLabel
                  value="muscle"
                  control={<Radio />}
                  label="Muscle"
                />
                <FormControlLabel
                  value="wire"
                  control={<Radio />}
                  label="Wireframe"
                />
                <FormControlLabel
                  value="mannequin"
                  control={<Radio />}
                  label="Mannequin"
                />
              </RadioGroup>
            </FormControl>
          </Box>
        </Grid>
        {/* <Grid item>
          <Box mb={2}>
            <FormControl component="fieldset">
              <FormLabel component="legend">Use Grid</FormLabel>
              <RadioGroup
                row
                aria-label="gender"
                name="use_grid"
                value={useGrid ? "y" : "n"}
                onChange={() => {
                  setUseGrid(!useGrid);
                }}
              >
                <FormControlLabel value="y" control={<Radio />} label="Yes" />
                <FormControlLabel value="n" control={<Radio />} label="No" />
              </RadioGroup>
            </FormControl>
          </Box>
        </Grid> */}
        <Grid item>
          <Button
            variant="contained"
            disableElevation
            color="primary"
            size="large"
            onClick={startSession}
          >
            Start Session!
          </Button>
          <p>{images.length} Images loaded</p>
        </Grid>
      </Stack>
      <Overlay
        open={modalOpen}
        image={randomImg}
        closeHandler={stopSession}
        refreshImg={refreshImg}
        timeLimit={timeLimit}
        sessionType={sessionType}
        theme={theme}
        darkMode={darkMode}
      />
    </Stack>
    </Fade>
  );
}

export default Home;
